// Shared Components
export * from "./header/header.component";
export * from "./footer/footer.component";




// WEBPACK FOOTER //
// ./src/app/components/shared/index.ts